// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { QbAdditionalContactDto } from './QbAdditionalContactDto';
import { QbContactBaseDto } from './QbContactBaseDto';
import {Guid} from "guid-typescript";

// AbilityIntranet.Data.Intranet.QbModels.QbCustomerContactDto
export class QbCustomerContactDto extends QbContactBaseDto {
    public qbCustomerGuid: Guid = null;
    public additionalContacts: QbAdditionalContactDto[] = [];
}


    



